/**
 *
 * @param {number} maxLength
 * @param {string} message
 * @returns
 */
export const validateNumberMaxLength = (maxLength, message) => {
  return (/**@type {string}*/ value) => {
    const parsedValue = value?.trim?.() || "";
    if (parsedValue === "" || parsedValue?.length !== maxLength) {
      return message;
    }
    return true;
  };
};

const requiredMessage = "Este campo es obligatorio";

export const validateRequiredRule = (message = requiredMessage) => {
  return (value) => {
    if (!value || value?.trim?.() === "") return message;
    return true;
  };
};

export const validatePpc = (isPpcValido) => () => {
  return isPpcValido ? true : "El código (PPC) ingresado es ínvalido";
};
